import { createAction } from "redux-act";
export var createForm = createAction("FORM_CREATE");
export var showErrors = createAction("FORM_SHOW_ERRORS");
export var storePartialFormData = createAction("FORM_DATA_STORE_PARTIAL");
export var updatePartialFormData = createAction("FORM_DATA_UPDATE_PARTIAL_FORM_DATA");
export var updatePartialFormDataBulk = createAction("FORM_DATA_UPDATE_PARTIAL_FORM_DATA_BULK");
